//https://indepth.dev/posts/1148/how-to-avoid-angular-injectable-instances-duplication
import { Injectable, Optional, SkipSelf } from '@angular/core';

@Injectable({
   providedIn: 'root'
})
export class GuardedSingletonService {
   constructor(@Optional() @SkipSelf() parent?: GuardedSingletonService) {
      if (parent) {
         console.log(`[GuardedSingletonService]: trying to create multiple instances,
        but this service should be a singleton.`)
         throw Error(
            `[GuardedSingletonService]: trying to create multiple instances,
        but this service should be a singleton.`
         )
      }
   }
}
